export const urlDespacho = 'https://gestiondeflota.boltrack.net/despachoapi/api/';
export const urlGestion = 'https://gestiondeflota.boltrack.net/api/datos';